import {
    useAddAutogeneratedLineup,
    useCurrencyConversionWs,
    useFantasyCurrencyConfig,
    useFantasyLineupListItems,
    useGetCompetitionStates,
    useGetUpdateCollectionsData,
    useGetUserTeams,
    useHandleAcceptInviteTeam,
    useUpdateSummaryStore,
} from '@pkg/hooks';

export const useFantasyLineupContent = () => {
    useGetUserTeams(false, true);
    useGetUpdateCollectionsData();
    useCurrencyConversionWs();
    useUpdateSummaryStore();
    useAddAutogeneratedLineup();
    useGetCompetitionStates();
    useFantasyCurrencyConfig();
    useFantasyLineupListItems();
    useHandleAcceptInviteTeam();
};
